
import { computed, defineComponent } from 'vue'
import { getContent } from '@/api'
import { RecentCarousel } from '@/components/carousel.vue'
import { dateFormatter } from '@/plugins/dateFormatter'

export default defineComponent({
  async setup () {
    let rawContent: RecentCarousel[] = []
    const res = await getContent(1, 2, 'default')
    rawContent = res.data.data
    const computedContent = computed(() => {
      return rawContent.map(item => {
        item.created = dateFormatter(item.created)
        return item
      })
    })
    return {
      computedContent
    }
  }
})
